export default function Divider(theme) {
  return {
    MuiDivider: {
      variants: [
        {
          props: { variant: "light" },
          style: {
            "&::before": {
              borderTopColor: theme.palette.common.white,
            },
            "&::after": {
              borderTopColor: theme.palette.common.white,
            },
          },
        },
        {
          props: { variant: "dark" },
          style: {
            "&::before": {
              borderTopColor: theme.palette.common.black,
            },
            "&::after": {
              borderTopColor: theme.palette.common.black,
            },
          },
        },
      ],
      styleOverrides: {
        // root: {
        //   "&::before": {
        //     borderTopColor: theme.palette.common.white,
        //   },
        //   "&::after": {
        //     borderTopColor: theme.palette.common.white,
        //   },
        // },
      },
    },
  };
}
